import status from "./statusKomplain";
const filterOptions = {
	sortItems: [
		{
			label: "Abjad A-Z",
			name: "sorting",
			value: JSON.stringify({
				sortBy: "1",
				orderBy: "ASC",
			}),
			id: "sorting-1"
		},
		{
			label: "Abjad Z-A",
			name: "sorting",
			value: JSON.stringify({
				sortBy: "1",
				orderBy: "DESC",
			}),
			id: "sorting-2"
		},
		{
			label: "Komplain terbaru",
			name: "sorting",
			value: JSON.stringify({
				sortBy: "2",
				orderBy: "DESC",
			}),
			id: "sorting-3"
		},
		{
			label: "Komplain Terlama",
			name: "sorting",
			value: JSON.stringify({
				sortBy: "2",
				orderBy: "ASC",
			}),
			id: "sorting-4"
		},
	],
	statusItems: status.map((item, index) => {
		return {
			id: 'fstatus-' + index,
			title: item.title,
			value: item.value,
			checked: false,
			titleBold: false,
		}
	})
};
export default filterOptions;